﻿
(() => {
    angular.module('fliptoWeb')
        .controller('BlogArticleCtrl', ['$http', '$stateParams', '$window', '$analytics', 'headService',
        function ($http, $stateParams, $window, $analytics, headService) {
            var vm = this;

            vm.currentUrl = headService.currentUrl();
            vm.socialShareTitle = "";
            vm.socialShareContent = "";
            vm.socialFeaturedImage = null;
            vm.isSubscribed = false;
            vm.isSubscribeError = false;

            vm.shareFacebook = () => {                
                //array of key/value objects
                var options = new Array();
                options.push('app_id=' + encodeURIComponent($window.SOCIAL_CONFIGURATION.facebookApiKey));
                options.push('display=' + encodeURIComponent('popup'));
                options.push('href=' + encodeURIComponent($window.location.href.replace($window.location.host, "www.flip.to")));
                //We trigger a new window with the Twitter dialog, in the middle of the page
                window.open($window.SOCIAL_CONFIGURATION.URL_DIALOG_BASE + 'share?' + options.join('&'), 'facebookWindow', 'height=266, width=550, top=' + ($window.innerHeight / 2 - 225) + ', left=' + $window.innerWidth / 2 + ',' +
                    ' toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            }

            vm.shareTwitter = ()=> {
                //We get the URL of the link
                var loc = $window.location.href;
                //We get the title of the link
                var title = vm.socialShareTitle;

                //array of key/value objects
                var options = new Array();
                options.push('url=' + encodeURIComponent(loc));
                options.push('text=' + encodeURIComponent(title));
                options.push('via=' + encodeURIComponent('fliptocom'));

                //We trigger a new window with the Twitter dialog, in the middle of the page
                window.open('https://twitter.com/intent/tweet?' + options.join('&'),
                    'twitterWindow',
                    'height=266, width=550, top=' + ($window.innerHeight / 2 - 225) + ', left=' + $window.innerWidth / 2 + ',' +
                    ' toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            }

            vm.shareLinkedIn = () => {
                //We get the URL of the link
                var loc = $window.location.href;
                //We get the title of the link
                var title = vm.socialShareTitle;

                //array of key/value objects
                var options = new Array();
                options.push('min=' + true);
                options.push('url=' + encodeURIComponent(loc));
                options.push('title=' + encodeURIComponent(title));
                options.push('summary=' + encodeURIComponent(vm.socialShareContent));

                //We trigger a new window with the Twitter dialog, in the middle of the page
                window.open('https://www.linkedin.com/shareArticle?' + options.join('&'),
                    'linkedInWindow',
                    'height=530, width=550, top=' + ($window.innerHeight / 2 - 225) + ', left=' + $window.innerWidth / 2 + ',' +
                    ' toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            }

            vm.shareGPlus = ()=> {
                //We get the URL of the link
                var loc = $window.location.href;

                //array of key/value objects
                var options = new Array();
                options.push('url=' + encodeURIComponent(loc));

                //We trigger a new window with the Twitter dialog, in the middle of the page
                window.open('https://plus.google.com/share?' + options.join('&'),
                    'googlePlusWindow',
                    'height=450, width=550, top=' + ($window.innerHeight / 2 - 225) + ', left=' + $window.innerWidth / 2 + ',' +
                    ' toolbar=0, location=0, menubar=0, directories=0, scrollbars=1');
            }

            $http
                .get('/api/blog/getArticle/' + $stateParams.articleSlug)
                .then((response)=> {
                response = response.data.Data;

                if (!response || response.errorCode) {
                    //TODO: handle error
                    return;
                }

                vm.socialShareTitle = response.Title;
                vm.socialShareContent = response.MetaDescription;
                vm.socialFeaturedImage = response.FeaturedImageUrl ? response.FeaturedImageUrl: null;

            });

            vm.subscribe = function (email) {
                $analytics.setUsername(email);
                $http.post("/api/subscriptions/add-blog-subscription", { Email: email })
                    .then(response => {
                        vm.isSubscribed = true;
                        vm.isSubscribeError = false;
                    }, error => {
                        vm.isSubscribed = false;
                        vm.isSubscribeError = true;
                    });
            };
            
            return vm;
        }]);
})()
